import { z } from 'zod'
import { ValueObject } from '@lukso/controllerapps-sharedlogic-ddd-core'
import { ChainID } from '@lukso/controllerapps-sharedlogic-primitives'

const InitialChainIDPropsSchema = z.object({
  initialChainIDValue: z.instanceof(ChainID),
})

type InitialChainIDProps = z.infer<typeof InitialChainIDPropsSchema>

export class InitialChainID extends ValueObject<InitialChainIDProps> {
  public getValue(): ChainID {
    return this.props.initialChainIDValue
  }

  public toNumber(): number {
    return this.props.initialChainIDValue.toNumber()
  }

  public static create(props: InitialChainIDProps): InitialChainID {
    const validatedProps = InitialChainIDPropsSchema.parse(props)
    return new InitialChainID(validatedProps)
  }
}
